export const HostedConstants = {
  CostDatabaseTypes: {
    RSMEANS: 'RSMEANS',
    DPROFILER: 'DPROFILER',
  },
  CostDatabaseConnectionTypes: {
    RSMEANS: 'RSMeans',
    BECK_TECH: 'Beck Tech',
  },
} as const;

export type CostDatabaseConnectionType =
  | typeof HostedConstants.CostDatabaseConnectionTypes.BECK_TECH
  | typeof HostedConstants.CostDatabaseConnectionTypes.RSMEANS;

export type CostDatabaseType =
  | typeof HostedConstants.CostDatabaseTypes.DPROFILER
  | typeof HostedConstants.CostDatabaseTypes.RSMEANS;
